/* eslint-disable prettier/prettier */
/**
 * This file exports all the components in this repository for rendering by @nerdwallet/react-composition. This includes
 * @nerdwallet/react-composition needs access to both components that only support the landing page builder, like `EditorControls`,
 * as well as components that are user-facing.
 *
 * This file merges the list of user-facing components (maintained in `./component-lib.js`) with the list of builder-specific
 * components.
 *
 * If you are building a component that needs to be *operated on* in the builder, i.e. inserted onto a page, deleted, edited, etc.,
 * you should add it to `./component-lib.js`, and it will be exported from this file by default. If you are building a component
 * that supports the landing page builder, and will not itself by edited by users of the builder, add it to this file and do not
 * add it to `./component-lib.js`.
 *
 * (This separation of concerns is necessary to prevent dependency cycles. Builder components may refer to `./component-lib.js` to
 * determine which components they may operate on, and cannot import themselves.)
 */

import universal from './universal';

export * from './component-lib.js';

export { default as Page } from '../components/page/page';
export const Downloader = universal(import('../components/downloader/downloader'));
export const Editor = universal(import('../containers/editor/editor'));
export const EditorControl = universal(import('../containers/editor-control/editor-control'));
export const ImporterJSONContainer = universal(import('../containers/importer-json-container/importer-json-container'));
